import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-origin"]
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 flex-shrink-0",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "max-w-[140px] truncate" }

import { computed } from 'vue'
import { mdiAccount, mdiAccountGroup } from '@mdi/js'

import type { PermissionTreeOrigin } from '@/Network/Types/Responses/PermissionResponses'

import { getOriginTooltip } from '../utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionOriginBadge',
  props: {
    origin: {}
  },
  setup(__props: any) {

const props = __props;



const label = computed(() => {
  if (props.origin.kind === 'direct') return 'Direta'
  return props.origin.group_name ? `Grupo · ${props.origin.group_name}` : 'Grupo'
})

/** "Direta — {relation}" ou "Grupo {nome} — {relation}", com sufixo "(herdada)". */
const tooltipText = computed(() => getOriginTooltip(props.origin))

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("span", {
    "data-testid": "permission-origin-badge",
    "data-origin": _ctx.origin.kind,
    class: _normalizeClass(["inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-2 py-1 text-xs font-medium", 
      _ctx.origin.kind === 'direct'
        ? 'border-primary10 bg-primary5 text-primary40'
        : 'border-purple-200 bg-purple-50 text-purple-700'
    ])
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: _ctx.origin.kind === 'direct' ? _unref(mdiAccount) : _unref(mdiAccountGroup),
        fill: "currentColor"
      }, null, 8, _hoisted_3)
    ])),
    _createElementVNode("span", _hoisted_4, _toDisplayString(label.value), 1),
    _createVNode(_component_v_tooltip, {
      activator: "parent",
      location: "top"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(tooltipText.value), 1)
      ]),
      _: 1
    })
  ], 10, _hoisted_1))
}
}

})